import { Status } from '@/engage/types/status'

export default Object.freeze({
  REOPENED: Status.REOPENED,
  RESERVED: Status.RESERVED,
  PENDING: Status.PENDING,
  INPROGRESS: Status.INPROGRESS,
})
